module.exports = __webpack_public_path__ + "img/ic-dropdown-black.1719cd98.svg";